<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5V6a1.5 1.5 0 001.5 1.5H4v13A1.5 1.5 0 005.5 22h13a1.5 1.5 0 001.5-1.5v-13h.5A1.5 1.5 0 0022 6V3.5A1.5 1.5 0 0020.5 2zM6 16.5V15h12v1.5zM18 14H6v-1.5h12zm0-2.5H6V10h12zm-12 6h5V20H6zm7 2.5v-2.5h5V20zm5-11H6V7.5h12zm2-3.5H4V4h16z"/></svg>